import { Rate } from 'antd';
import { Component } from 'react';

import movieDB from '../../assets/js/apiModule';
import { GenreConsumer } from '../GenreContext/GenreContext';

import s from './FilmItem.module.scss';
import './Rating.scss';

class FilmItem extends Component {
	movieService = new movieDB();

	state = {
		rating: this.props.ratingValue,
		ratingColor: '',
	};

	componentDidMount() {
		this.checkRatingColor(this.props.ratingValue);
	}

	checkRatingColor(value) {
		if (value >= 0 && value < 3) this.setState({ ratingColor: '#E90000' });
		if (value >= 3 && value < 5) this.setState({ ratingColor: '#E97E00' });
		if (value >= 5 && value < 7) this.setState({ ratingColor: '#E9D100' });
		if (value >= 7) this.setState({ ratingColor: '#66E900' });
	}

	onChangeRating = (value) => {
		this.setState({
			rating: value,
		});
		localStorage.setItem(this.props.id, value);
		this.checkRatingColor(value);
		if (value) {
			this.movieService.rateMovie(this.props.id, localStorage.getItem('guest_session_id'), value);
		}
	};

	renderGenres = (genres, genreIds) => {
		const result = genres.map((id) => {
			const result = genreIds.map((el) => {
				if (id === el.id) {
					return (
						<div key={el.id + 'genre'} className={s.genre__item}>
							{el.name}
						</div>
					);
				} else return null;
			});
			return result;
		});
		return result;
	};

	render() {
		const { img, title, date, text, genre, mobile } = this.props;
		const { rating } = this.state;

		const ratingBorder = {
			border: `2px solid ${this.state.ratingColor}`,
		};

		return (
			<GenreConsumer>
				{(genreIds) => {
					return (
						<div className={s.filmItem}>
							<div className={s.wrapper}>
								<div className={s.img}>
									<img src={img} alt="test" />
								</div>
								<div className={s.descr}>
									<div className={s.title__wrapper}>
										<div className={s.title}>{title}</div>
										<div className={s.rating} style={ratingBorder}>
											{rating}
										</div>
									</div>
									<div className={s.date}>{date}</div>
									<div className={s.genre}>{this.renderGenres(genre, genreIds)}</div>
									{!mobile && (
										<>
											<div className={s.text}>{text}</div>
											<Rate allowHalf defaultValue={rating} count={10} className="stars" onChange={this.onChangeRating} />
										</>
									)}
								</div>
							</div>
							{mobile && (
								<div className={s.mobile}>
									<div className={s.text}>{text}</div>
									<Rate allowHalf defaultValue={rating} count={10} className="stars" onChange={this.onChangeRating} />
								</div>
							)}
						</div>
					);
				}}
			</GenreConsumer>
		);
	}
}

export default FilmItem;
